import React, { useState, useEffect } from "react";
import { NotifyConfirm } from "../../../../components/notify/Notify";
import { createPermissionCRUD } from "../../../../apis/System/permission.api";
import {
  createAccessControl,
  getParentAC,
  removeAccessControl,
  updateAccessControl,
} from "../../../../apis/System/accessControl.api";
import { path } from "../../../../constants/path";
import { useGetPermissionAccessControl } from "src/context/PermissionAccessControl";
import useControlPanel from "src/hooks/useControlPanel";
import useDebounce from "src/hooks/useDebounce";
import AccessControlPopup from "../../components/Popup/AccessControlPopup";
import ControlPanelSystem from "src/components/controlPanelSystem/ControlPanelSystem";
import AccessControlPanel from "../../components/ControlPanel/AccessControlPanel";
import AccessControlTable from "../../components/Table/AccessControlTable";
import Pagination from "src/components/Pagination/Pagination";

const initAccessControlData = {
  list: [],
  total_record: 0,
};

const titlePage = "Access control";

const AccessControl = () => {
  // start refactor
  const permissionsAccessControl = useGetPermissionAccessControl();
  const {
    searchKey,
    numberPage,
    setNumberPage,
    limit,
    setLimit,
    status,
    setStatus,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    handleInputChange,
    handleChangePage,
  } = useControlPanel();

  const [accessControlData, setAccessControlData] = useState(
    initAccessControlData
  );
  const [filterAccessControls, setFilterAccessControls] = useState([]);
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [errorsForm, setErrorsForm] = useState({});
  let search = useDebounce(searchKey, 500);

  const [parentRoute, setParentRoute] = useState("");
  const [parentRouteId, setParentRouteId] = useState("");
  // end refactor

  useEffect(() => {
    const query = {
      page: numberPage,
      limit,
      searchKey: search,
      startDate,
      endDate,
      status,
    };
    getParentAC(query, (result) => {
      setAccessControlData(result);
      setFilterAccessControls([...result.list]);
    });
  }, [endDate, limit, numberPage, search, startDate, status]);

  const handleOpenPopup = (item, parentRoute, parentRouteId) => {
    setOpenPopup(true);
    setRecordForEdit(item);
    setParentRoute(parentRoute);
    setParentRouteId(parentRouteId);
    setErrorsForm({});
  };

  const actionAfterCreateOrUpdate = (result, resetForm) => {
    if (result.data?.status === 422) {
      setErrorsForm({ ...result.data.data });
    } else {
      resetForm();
      window.location.reload(true);
    }
  };

  const addOrEdit = (accessControl, resetForm) => {
    if (!accessControl.id) {
      const infoCreatePermission = {
        routeName: accessControl.childRoute,
        permissionAction: accessControl.permissionAction,
        name: accessControl.name,
      };

      createPermissionCRUD(infoCreatePermission, (result) => {
        accessControl = {
          ...accessControl,
          permissionIds: result,
        };
        createAccessControl(
          { ...accessControl, route: accessControl.childRoute },
          (result) => {
            actionAfterCreateOrUpdate(result, resetForm);
          }
        );
      });
    } else {
      const body = {
        permissionAction: accessControl.permissionAction,
        name: accessControl.name,
        route: accessControl.childRoute,
      };
      updateAccessControl(accessControl.id, body, (result) => {
        actionAfterCreateOrUpdate(result, resetForm);
      });
    }
  };

  const handleDelete = (id) => {
    NotifyConfirm("warning", "Are you delete it ?", (result) => {
      if (result.isConfirmed) {
        // * tìm vị trí của trong list
        const foundAccessControl = accessControlData.list.findIndex(
          (accessControl) => accessControl.id === id
        );

        if (foundAccessControl !== -1) {
          removeAccessControl(id, (_) => {
            window.location.reload(true);
          });
        }
      }
    });
  };

  return (
    <div>
      <div>
        <div className="page-header">
          <h2>{titlePage}</h2>
        </div>

        <AccessControlPopup
          recordForEdit={recordForEdit}
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
          addOrEdit={addOrEdit}
          parentRoute={parentRoute}
          parentRouteId={parentRouteId}
          errorsForm={errorsForm}
        />

        <AccessControlPanel
          permissionsAccessControl={permissionsAccessControl}
          handleOpenPopup={handleOpenPopup}
        >
          <ControlPanelSystem
            searchKey={searchKey}
            handleInputChange={(e) => handleInputChange(e)}
            limit={limit}
            setLimit={setLimit}
            setNumberPage={setNumberPage}
            status={status}
            setStatus={setStatus}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
          />
        </AccessControlPanel>

        <AccessControlTable
          data={filterAccessControls}
          handleOpenPopup={handleOpenPopup}
          handleDelete={handleDelete}
          status={status}
        />
      </div>

      <Pagination
        pathname={`${path.systemAccessControl}`}
        page={numberPage}
        handleChangePage={(page) => handleChangePage(page)}
        limit={limit}
        pageSize={accessControlData.total_record}
      />
    </div>
  );
};

export default AccessControl;
